import classNames from 'classnames';
import { useState, type JSX } from 'react';
import { CardActionIcon } from './CardActionIcon';
import { CardActionType } from '../../../../../types/decks';
import { useActions } from '../../../../../hooks/useActions';

export function CardAction({
  cardAction,
  actions,
}: {
  cardAction: CardActionType;
  actions: ReturnType<typeof useActions>;
}): JSX.Element {
  const [hover, setHover] = useState(false);
  return (
    <div className="flex mt-2 first:mt-0 items-center">
      <div
        className={`flex mr-2 items-center ${
          hover ? 'opacity-100' : 'opacity-0'
        } ease-in duration-300 transition`}
      >
        <div className="p-[10px] bg-neutral-800 justify-center flex">
          <p className="text-label-s text-white" style={{ lineHeight: '8px' }}>
            {cardAction.title}
          </p>
        </div>
        <div className="-ml-[1px]">
          <RightArrow />
        </div>
      </div>
      <div
        className={`${hover ? 'bg-white' : 'bg-opacity-midnight-700'}
                        w-6 h-6 p-1 justify-center items-center rounded-full flex transition-transform`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={async e => {
          e.preventDefault();
          await actions(cardAction.action);
          return false;
        }}
      >
        <CardActionIcon icon={cardAction.icon} className={classNames({ invert: !hover })} />
      </div>
    </div>
  );
}

function RightArrow() {
  return (
    <div
      className="w-0 h-0 
  border-t-[6px] border-t-transparent
  border-l-[9px] border-l-neutral-800
  border-b-[6px] border-b-transparent"
    ></div>
  );
}
